import { useMemo } from 'react';
import { useCookies } from './useCookies';

export const useSegmentAnonymousId = () => {
  const { cookies } = useCookies();

  return useMemo(() => cookies.ajs_anonymous_id?.replace(/"/g, ''), [cookies.ajs_anonymous_id]);
};
